/**
 * Groups given booth refinements
 * 
 * @param {Array} boothRefinements 
 * @returns {Array}
 */
export const groupRefinements = (boothRefinements) => {
  const refinements = boothRefinements.filter((refinement) => refinement.configurations.length > 0)

  if (refinements.length === 0) {
    return []
  }

  if (refinements.length === 1) {
    return [
      refinements
    ]
  }

  return [
    ...refinements
      .reduce((a, b) => a.set(b.configurations[0].group, [...a.get(b.configurations[0].group) || [], b]), new Map())
      .values()
  ]
}

/**
 * Returns if refinement is available if at least one booth refinement article is not disabled
 * 
 * @param {Object} refinement 
 * @param {Array} disabledBoothRefinementArticleIds
 * @param {Array} bookableArticleIds
 * @returns {Boolean}
 */
export const isRefinementAvailable = (refinement, disabledBoothRefinementArticleIds, bookableArticleIds) => {
  if (disabledBoothRefinementArticleIds.length === 0) {
    return true
  }

  if (
    refinement.articles === undefined
    || refinement.articles === null
    || refinement.articles.length === 0
    || bookableArticleIds.length === 0) {
    return false
  }

  let availableArticlesCount = refinement.articles.length
  refinement.articles.forEach(boothRefinementArticle => {
    if (
      disabledBoothRefinementArticleIds.includes(boothRefinementArticle.id)
      || !bookableArticleIds.includes(boothRefinementArticle.article_id)
    ) {
      availableArticlesCount--
    }
  })

  return availableArticlesCount > 0
}

/**
 * Returns all booth refinement articles which are not disabled
 *
 * @param {Array} boothRefinementArticles
 * @param {Array} disabledBoothRefinementArticleIds
 * @param bookableArticleIds
 * @param isSeamlessPrint
 * @returns {Array}
 */
export const filterAvailableBoothRefinementArticles = (
    boothRefinementArticles,
    disabledBoothRefinementArticleIds,
    bookableArticleIds,
    isSeamlessPrint = 0
) => {
  return boothRefinementArticles.filter(boothRefinementArticle =>
      !disabledBoothRefinementArticleIds.includes(boothRefinementArticle.id) &&
      bookableArticleIds.includes(boothRefinementArticle.article_id) &&
      boothRefinementArticle.is_seamless_print === isSeamlessPrint
  );
}

export const filterAvailableRefinements = (
  shoppingCart,
  disabledBoothRefinementArticleIds,
  mandatoryMode,
  bookableArticleIds
) => {
  if (shoppingCart.booth === null || shoppingCart.booth_type === null) {
    return []
  }
  return shoppingCart.booth.refinements.filter(refinement => {
    if (refinement.articles.length === 0) {
      return false
    }
    const usedRefinements = shoppingCart.booth_configuration.map(configuration => {
      return configuration.id
    })

    if (mandatoryMode) {
      return !usedRefinements.includes(refinement.id)
        && refinement.mandatory 
        && refinement.booth_type === shoppingCart.booth_type.type
        && true
    }

    return !usedRefinements.includes(refinement.id) 
      && refinement.booth_type === shoppingCart.booth_type.type
  })
    .filter(refinement => {
      return isRefinementAvailable(refinement, disabledBoothRefinementArticleIds, bookableArticleIds)
    })
    .sort((a, b) => {
      if (a.order > b.order) {
          return 1
        }

        return (a.order === b.order) ? 0 : -1
    })
}